export default __webpack_public_path__ + "static/media/Group.9.mod.eeb3ed7c.png";